import { Component } from '@angular/core';
import { StateIndicatorType } from '@uigy/shared/components/icons/interfaces';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { IconsEnum } from '@uigy/generated/icons.enum';
import {
  UiStateIndicatorComponent
} from '@uigy/shared/components/icons/ui-state-indicator/ui-state-indicator.component';

export interface StateIndicatorCellRendererParams<T = StateIndicatorType> extends ICellRendererParams {
  text?: string;
  stateToIconMapping?: (x: T) => IconsEnum;
  stateToClassMapping?: (x: T) => 'blue' | 'green' | 'red' | 'grey';
  value: T;
}
/**
 * Cell renderer that uses the UiStateIndicatorComponent to display a state/status with an icon and optional text.
 * default use is to apply StateIndicatorType enum to represent different states.
 * If different states are needed, generic type T can be used along with mapping functions.
 *
 * @stateToIconMapping Optional function to map state to a specific icon.
 * @stateToClassMapping Optional function to map state to a specific CSS class for styling
 */
@Component({
  selector: 'app-state-indicator-cell-renderer',
  templateUrl: './state-indicator-cell-renderer.component.html',
  styleUrls: ['./state-indicator-cell-renderer.component.scss'],
  imports: [
    UiStateIndicatorComponent
  ],
})
export class StateIndicatorCellRendererComponent<T = StateIndicatorType> implements ICellRendererAngularComp {
  public state?: T;
  public text: string = '';
  public stateToIconMapping?: (x: T) => IconsEnum;
  public stateToClassMapping?: (x: T) => 'blue' | 'green' | 'red' | 'grey';

  public agInit(params: StateIndicatorCellRendererParams<T>): void {
    this.state = params.value;
    this.text = params.valueFormatted ?? params.text ?? '';
    this.stateToIconMapping = params.stateToIconMapping;
    this.stateToClassMapping = params.stateToClassMapping;
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params as unknown as StateIndicatorCellRendererParams<T>);
    return false;
  }
}
